<template>
  <div id="app">
    <loadingcomp
      ref="loadingcomp"
      v-bind:mesaj="loadingmesaj"
      v-model="loadingdialog"
    ></loadingcomp>
    <v-card flat color="grey lighten-5">
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title>Genel Amacli Raporu</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
        </v-flex>
        <v-flex xs12 sm12>
          <v-form ref="formgenelamacli" v-model="valid" lazy-validation>
            <v-container fluid="">
              <v-card flat>
                <v-layout class="project overdue" pa-1 row wrap="">
                  <v-flex xs12 sm3 md2>
                    <tarihim
                      :etiket="'Başlangıç Tarihi'"
                      :detaygizle="true"
                      v-model="prm.BaslangicTarih"
                      v-bind:defaultvalue="'ok'"
                      :rules="[(v) => !!v || 'Lütfen tarih seçiniz']"
                    >
                    </tarihim>
                  </v-flex>

                  <v-flex xs12 sm3 md2>
                    <tarihim
                      :etiket="'Bitiş Tarihi'"
                      :detaygizle="false"
                      v-model="prm.BitisTarih"
                      v-bind:defaultvalue="'ok'"
                      :rules="[(v) => !!v || 'Lütfen tarih seçiniz']"
                    >
                    </tarihim>
                  </v-flex>

                  <v-flex  xs12 sm4 md4>
                    <v-select
                      v-model="item"
                      :items="items"
                      item-text="TemplateName"
                      item-value="TemplateId"
                      label="Rapor Şablonu"
                      return-object
                    >
                    </v-select>
                  </v-flex>

                  <v-flex xs12 sm3 md2>
                    <v-layout>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-on="on"
                            color="green"
                            @click="getGenelAmacliExcel()"
                            fab
                            small=""
                            dark
                            ref="fab"
                          >
                            <img
                              style="height: 32px; width: 32px"
                              src="../../../../assets/images/xls.png"
                            />
                          </v-btn>
                        </template>
                        <span>Rapor İndir</span>
                      </v-tooltip>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-container>
          </v-form>
        </v-flex>
      </v-layout>
    </v-card>

    <v-snackbar
      :timeout="timeout"
      :top="y === 'top'"
      :bottom="y === 'bottom'"
      :right="x === 'right'"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :vertical="mode === 'vertical'"
      v-model="snackbar"
    >
      {{ text1 }}
      <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import tarihim from "@/components/app/customcomp/tarihim.vue";
import helpers from "@/components/app/customcomp/helpers.js";
import loadingcomp from "@/components/app/customcomp/loadingcomp.vue";
import tarihinput from "@/components/app/customcomp/tarihim.vue";
import tool from "../../coper/tools";
import auth from '../../../../api/auth'

export default {
  data() {
    return {
      item:null,
      sablon: {
        design: [],
      },
      loadingmesaj: "Excel rapor hazırlama ",
      loadingdialog: false,
      searchIcon: "search",
      date: null,
      menu: false,
      modal: false,
      dateFormatted: "",
      date2: null,
      menu2: false,
      dateFormatted2: "",
      modal2: false,
      harekettipi: "",
      items: [],
      load: false,
      load1: true,
      dialog: false,
      progress: false,
      valid: true,
      snackbar: false,
      y: "top",
      x: "right",
      mode: "",
      timeout: 6000,
      text1: "",
      tooltip: false,
      el: null,
      prm: {
        SirketKodu: null,
        BaslangicTarih: null,
        BitisTarih: null,
        TarihTip: 0, // 0 : Satış Tarihi,  1 : Ucuş Tarihi, 2 : Fatura Tarihi , 3 : Iade Fatura Tarihi
        CariKod: null,
        Havayollari: [],
        BaslangicBiletNo: null,
        BitisBiletNo: null,
        Referanslar: [],
        Masraflar: [],
        Parkurlar: [],
        Classlar: [],
        YolcuAdi: null,
        BiletAciklama: null,
        HatTipi: 0, // 0 : Hepsi, 1 : İç Hat, 2: Dis Hat, 3: Bsp
        SatisTipi: 0, // 0 : Hepsi, 1 : Satış, 2: Iade
        OdemeTipi: 0, // 0 : Hepsi, 1 : Kredili, 2 : Peşin, 3: R-Kartlı, 4: F-Kartlı, 5: C-Kartlı
        FaturaNo: null,
        KesenKisi: null,
        HesapGruplari: [],
        Dovizler: [],
        AnaHesap: null,
        AcentaKodu: null,
        AnalizKodu: null,
        DepartmanKodu: null,
        PinKodu: null,
        ClassTip: null,
        BiletYon: 0, // 0 : Hepsi, 1 : Tek Yon, 2 : Cift Yon, 3: Ressiue
        CrsTip: null,
        Efaturali: false,
        Siralama: 0, //0 : Bilet Sırası, 1: Satış Tarihi , 2 : Kesim Tarihi, 3: Ucuş Tarihi
        AltHesapGoster:true,
      },
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  methods: {
    getGenelAmacliExcel() {

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loadingdialog = true;
          var bastarih = new Date(this.date);
          var bittarih = new Date(this.date2);

          if (bastarih <= bittarih) {

            var credentials = JSON.parse(
              window.localStorage.getItem("credentials")
            );

            this.progress = true;
            this.prm.SirketKodu = credentials.CariBilgi.SirketKodu;
            this.prm.CariKod = credentials.CariBilgi.Kod;

            var params = {
              prm: this.prm,
              objectName: "Models.GenelAmacliClass",
              id: this.item.TemplateId,
            };

            this.load1 = false;
            this.load = true;

            tool
              .api_post_FileDownload(this, "RaporSablon/GetReportExcel", params)
              .then(
                (response) => {

                  var blob = new Blob([response.data], {
                    type: "application/xlsx",
                  });
                  var link = document.createElement("a");
                  link.href = window.URL.createObjectURL(blob);
                  link.download = "GetReport.xlsx";
                  link.click();
                  this.loadingdialog = false;
                },
                (response) => {
                  this.loadingdialog = false;
                  this.progress = false;
                  this.load1 = true;
                  this.load = false;
                }
              );
          } else {
            this.loadingdialog = false;
            this.text1 = "Başlangıç tarihi bitiş tarihinden büyük olamaz...";
            this.snackbar = true;
          }
        }
      });
    },

    getparabirimi() {
      return helpers.getparabirimi();
    },
  },

  mounted() {
            var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      var Params ={
          CompanyCode: credentials.CariBilgi.SirketKodu,
          AccountCode: credentials.CariBilgi.Kod
      }
      this.$http
        .post(
          auth.API_URL + "api/Current/GetOzelSablon",
          Params,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            this.items = response.body;

            
              if (this.items.length > 0) {
                this.item = this.items[0];
              } else {
                this.item = null;
              }
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Hata Oluştu";
              this.snackbar = true;
              this.load1 = true;
              this.progress = false;
            } else {
              this.text1 = "Hata Oluştu";
              this.snackbar = true;

              this.load1 = true;
              this.progress = false;
            }
          }
        );
    
    this.el = this.$refs.fab.$el;
    this.date = helpers.getDateNow();
    this.date2 = helpers.getDateNow();
  },
  components: {
    tarihim,
    loadingcomp,
    tarihinput,
  },
  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },

    bakiyekontrol: function (m) {
      return helpers.bakiyekontrol(m);
    },
  },
};
</script>

<style>
.v-list__tile__content {
  overflow: inherit;
}
</style>
